import { render, staticRenderFns } from "./DiscussionsWidget.vue?vue&type=template&id=410d7714"
import script from "./DiscussionsWidget.vue?vue&type=script&lang=js"
export * from "./DiscussionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports